import { render, staticRenderFns } from "./EvaluatorList.vue?vue&type=template&id=d2795494"
import script from "./EvaluatorList.vue?vue&type=script&lang=js"
export * from "./EvaluatorList.vue?vue&type=script&lang=js"
import style0 from "./EvaluatorList.vue?vue&type=style&index=0&id=d2795494&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports